import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  .input-container {
    max-width: 754px;
    margin: auto;
    aspect-ratio: 3/4;
  }
  .ant-input {
    padding: 24px;
    font-family: inherit !important;
    font-weight: 700;
  }
  .input-label {
    margin: 0;
    margin-bottom: 16px;
    font-size: 18px;
    font-weight: 700;
  }
  .custom-button {
    margin: 24px auto;
  }
  .copy-button {
    display: flex !important;
    justify-content: center;
    align-items: center;
    column-gap: 8px;
    font-weight: 500;
    cursor: pointer;
  }
  .anticon svg {
    font-size: 20px;
  }
  .ant-alert {
    margin-bottom: 24px;
  }
  .ant-tabs-bar {
    display: flex;
    justify-content: center;
    border:none;
  }
`;

export const KeyRotationCard = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f0f7ff;
  border-radius: 8px;
  padding: 16px 24px;
  margin-bottom: 24px;

  .rotation-info {
    .rotation-title {
      font-weight: 600;
      font-size: 16px;
      margin-bottom: 4px;
    }
    .rotation-details {
      color: #666;
      font-size: 14px;
    }
    .rotation-expiry {
      color: #666;
      font-size: 14px;
    }
  }

  .days-remaining {
    text-align: right;
    .days-count {
      font-size: 32px;
      font-weight: 600;
      color: #1890ff;
      display: block;
    }
    .days-label {
      font-size: 14px;
      color: #666;
    }
  }
`;
